import styled from 'styled-components';

export const EditorContainer = styled.section`
  padding: 10px;
  ${({ inline }) => inline && 'box-shadow: 0px 0px 8px #888888'}; 
`;